// nearest-store.js - Universal Store Locator
// Works across all store region pages

(function() {
  'use strict';

  // Haversine formula to calculate distance between two coordinates
  function haversine(lat1, lon1, lat2, lon2) {
    const R = 6371; // Earth's radius in kilometers
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos((lat1 * Math.PI) / 180) * 
      Math.cos((lat2 * Math.PI) / 180) * 
      Math.sin(dLon / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  // Initialize the nearest store feature
  function initNearestStore() {
    const nearestBtn = document.getElementById('findNearestBtn');
    const nearestPopup = document.getElementById('nearest-store-popup');
    const storeCards = Array.from(document.querySelectorAll('.store-card'));

    // Exit if required elements don't exist
    if (!nearestBtn || !nearestPopup || storeCards.length === 0) {
      console.log('Nearest store feature: Required elements not found on this page');
      return;
    }

    console.log(`Nearest store feature initialized with ${storeCards.length} stores`);

    // Remove any existing event listeners by cloning the button
    const newNearestBtn = nearestBtn.cloneNode(true);
    nearestBtn.parentNode.replaceChild(newNearestBtn, nearestBtn);

    // Add click event listener
    newNearestBtn.addEventListener('click', function() {
      // Check if geolocation is supported
      if (!navigator.geolocation) {
        nearestPopup.innerHTML = `
          <div style="color:#e53e3e;text-align:center;">
            Geolocation is not supported by your browser.
          </div>
        `;
        return;
      }

      // Show loading message
      nearestPopup.innerHTML = `
        <div style="text-align:center;color:#4a5568;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation:spin 1s linear infinite;display:inline-block;">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 6v6l4 2"></path>
          </svg>
          <span style="margin-left:8px;">Detecting your location...</span>
        </div>
        <style>
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        </style>
      `;

      // Get user's current position
      navigator.geolocation.getCurrentPosition(
        function(position) {
          const userLat = position.coords.latitude;
          const userLng = position.coords.longitude;
          
          let nearest = null;
          let minDist = Infinity;

          // Find the nearest store
          storeCards.forEach(function(card) {
            const lat = parseFloat(card.dataset.lat);
            const lng = parseFloat(card.dataset.lng);
            
            // Skip if coordinates are invalid
            if (isNaN(lat) || isNaN(lng)) {
              console.log('Invalid coordinates for store:', card);
              return;
            }

            const distKm = haversine(userLat, userLng, lat, lng);
            
            if (distKm < minDist) {
              minDist = distKm;
              nearest = card;
            }
          });

          // Display result
          if (nearest) {
            // Remove highlight from all stores
            storeCards.forEach(function(card) {
              card.classList.remove('highlight-store');
            });
            
            // Highlight the nearest store
            nearest.classList.add('highlight-store');
            
            // Scroll to the nearest store
            nearest.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'center' 
            });

            // Get store information
            const storeName = nearest.querySelector('.store-name')?.textContent || 'Store';
            const addressElement = nearest.querySelector('.store-address');
            const address = addressElement?.textContent || 'Address unavailable';
            
            // Get or construct maps link
            let mapsLink = nearest.dataset.link;
            if (!mapsLink || mapsLink.trim() === '') {
              const addressEncoded = encodeURIComponent(address);
              mapsLink = `https://www.google.com/maps/dir/?api=1&destination=${addressEncoded}`;
            }
            
            // Convert distance to miles
            const miles = (minDist * 0.621371).toFixed(1);

            // Display the result
            nearestPopup.innerHTML = `
              <div style="display:flex;flex-direction:column;align-items:center;gap:8px;text-align:center;color:#2d3748;line-height:1.5;">
                
                <div style="display:flex;align-items:center;gap:6px;justify-content:center;">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="7" width="18" height="13" rx="2" ry="2"></rect>
                    <path d="M16 3h-8v4h8V3z"></path>
                  </svg>
                  <strong>${storeName}</strong>
                </div>

                <div style="display:flex;align-items:center;gap:6px;justify-content:center;color:#4a5568;">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                  <span>${address}</span>
                </div>

                <div style="display:flex;align-items:center;gap:6px;justify-content:center;color:#4a5568;">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 12h16M12 20V4"></path>
                  </svg>
                  <span>Approx. <b>${miles} miles</b> away</span>
                </div>

                <div style="display:flex;align-items:center;gap:6px;justify-content:center;margin-top:4px;">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3182ce" stroke-width="2">
                    <polyline points="1 6 8 3 16 6 23 3 23 18 16 21 8 18 1 21 1 6"></polyline>
                    <line x1="8" y1="3" x2="8" y2="18"></line>
                    <line x1="16" y1="6" x2="16" y2="21"></line>
                  </svg>
                  <a href="${mapsLink}" target="_blank" rel="noopener" style="color:#3182ce;text-decoration:underline;font-weight:500;">
                    View on Google Maps
                  </a>
                </div>
              </div>
            `;
          } else {
            nearestPopup.innerHTML = `
              <div style="color:#e53e3e;text-align:center;">
                ❌ No store coordinates found. Please ensure stores have valid latitude and longitude data.
              </div>
            `;
          }
        },
        function(error) {
          // Handle geolocation error
          let errorMessage = 'Unable to retrieve your location.';
          
          switch(error.code) {
            case error.PERMISSION_DENIED:
              errorMessage = 'Location access denied. Please enable location permissions in your browser.';
              break;
            case error.POSITION_UNAVAILABLE:
              errorMessage = 'Location information unavailable.';
              break;
            case error.TIMEOUT:
              errorMessage = 'Location request timed out.';
              break;
          }
          
          nearestPopup.innerHTML = `
            <div style="color:#e53e3e;text-align:center;">
              ${errorMessage}
            </div>
          `;
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNearestStore);
  } else {
    initNearestStore();
  }

  // Re-initialize when navigating between pages (for Shopify themes with AJAX navigation)
  document.addEventListener('shopify:section:load', initNearestStore);
  
  // Also listen for custom events that might indicate page changes
  window.addEventListener('pageshow', initNearestStore);

})();